import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box } from '@mui/material';

interface TabItem {
  label: string;
  content: React.ReactNode;
}

interface TabsContainerProps {
  tabs: TabItem[];
  activeTab?: number;
  onTabChange?: (tabIndex: number) => void;
  disabledTabs?: number[];
}

const TabsContainer: React.FC<TabsContainerProps> = ({ tabs, activeTab, onTabChange, disabledTabs = [] }) => {
  const [currentTab, setCurrentTab] = useState(activeTab || 0);

  useEffect(() => {
    if (activeTab !== undefined) {
      setCurrentTab(activeTab);
    }
  }, [activeTab]);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    // No permitir cambiar a tabs deshabilitados
    if (disabledTabs.includes(newValue)) {
      return;
    }
    setCurrentTab(newValue);
    if (onTabChange) {
      onTabChange(newValue);
    }
  };

  return (
    <Box>
      <Tabs value={currentTab} onChange={handleChange}>
        {tabs.map((tab, index) => (
          <Tab 
            key={index} 
            label={tab.label} 
            disabled={disabledTabs.includes(index)}
          />
        ))}
      </Tabs>
      <Box mt={2}>
        {tabs[currentTab]?.content}
      </Box>
    </Box>
  );
};

export default TabsContainer;
